import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    },
    attrs: {
      id: "brandList"
    }
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticClass: "table-page-search-wrapper"
  }, [_c("a-form", {
    attrs: {
      layout: "inline"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getQueryList.apply(null, arguments);
      }
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 48
    }
  }, [_c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("brandList.brandName"),
      labelCol: {
        span: 5,
        offset: 0
      }
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("brandList.enterPlease")
    },
    model: {
      value: _vm.listQuery.brandName,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "brandName", $$v);
      },
      expression: "listQuery.brandName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("brandList.stutus")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("brandList.choosePlease"),
      "default-value": undefined
    },
    model: {
      value: _vm.listQuery.brandStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "brandStatus", $$v);
      },
      expression: "listQuery.brandStatus"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("brandList.stopUsing")))]), _c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("brandList.startUsing")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("span", {
    staticClass: "table-page-search-submitButtons",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.tableLoading
    },
    on: {
      click: _vm.getQueryList
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.inquire2")) + " ")])], 1)])], 1)], 1)], 1)]), _c("a-card", {
    staticStyle: {
      "margin-top": "24px",
      position: "relative",
      flex: "1 1 0%"
    },
    attrs: {
      id: "table",
      bordered: false
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.addBrand();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("brandList.add")))])], 1), _c("a-table", {
    ref: "brandList",
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      rowKey: "id",
      loading: _vm.isTableLoading,
      "data-source": _vm.brandList,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("brandList.total"), "\uFF1A") + _vm.listTotal;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.listTotal
      }
    },
    on: {
      change: _vm.tableChange
    }
  }, [_c("a-table-column", {
    attrs: {
      "data-index": "brandName",
      align: "left",
      width: "25%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("span", [_vm._v(_vm._s(text))])];
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("brandList.brandName")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.defaultLangObj.langName) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1)]), _c("a-table-column", {
    key: "productNumber",
    attrs: {
      "data-index": "productNumber",
      title: _vm.$t("brandList.productNum"),
      align: "left",
      sorter: false,
      width: "10%",
      sortOrder: _vm.sortedInfo.columnKey === "productNumber" && _vm.sortedInfo.order
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("div", {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c("div", {
          staticStyle: {
            "margin-bottom": "4px"
          }
        }, [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.onTheShelf")))]), _vm._v("： "), _c("router-link", {
          staticStyle: {
            "text-decoration": "underline"
          },
          attrs: {
            to: {
              path: "/productmanager/productList",
              query: {
                productStatus: 1,
                productBrandid: record.id
              }
            }
          }
        }, [_vm._v(_vm._s(record.productNumberOn || 0))])], 1), _c("div", [_c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("productList.offTheShelf")))]), _vm._v("： "), _c("router-link", {
          staticStyle: {
            "text-decoration": "underline"
          },
          attrs: {
            to: {
              path: "/productmanager/productList",
              query: {
                productStatus: 0,
                productBrandid: record.id
              }
            }
          }
        }, [_vm._v(_vm._s(record.productNumberOff || 0))])], 1)])];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      "data-index": "firstLetters",
      title: _vm.$t("brandList.firstLetter"),
      align: "left",
      width: "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text) {
        return [_c("div", {
          staticStyle: {
            "line-height": "30px"
          }
        }, _vm._l(text, function (letter) {
          return _c("a-tag", [_vm._v(_vm._s(letter))]);
        }), 1)];
      }
    }])
  }), _c("a-table-column", {
    key: "brandStatus",
    attrs: {
      "data-index": "brandStatus",
      sortOrder: _vm.sortedInfo.columnKey === "brandStatus" && _vm.sortedInfo.order,
      title: _vm.$t("brandList.stutus"),
      align: "left",
      sorter: "true",
      width: "10%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text) {
        return [text == 0 ? [_c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("brandList.stopUsing")) + " ")])] : [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("brandList.startUsing")) + " ")])]];
      }
    }])
  }), _c("a-table-column", {
    key: "updateTime",
    attrs: {
      "data-index": "updateTime",
      "default-sort-order": "ascend",
      title: _vm.$t("brandList.updateTime"),
      sortOrder: _vm.sortedInfo.columnKey === "updateTime" && _vm.sortedInfo.order,
      align: "left",
      sorter: "true",
      width: "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text) {
        return [_c("span", [_vm._v(_vm._s(text))])];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("brandList.operation"),
      align: "left",
      width: "15%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("a-button", {
          staticStyle: {
            padding: "0"
          },
          attrs: {
            type: "link"
          },
          on: {
            click: function click($event) {
              return _vm.editBrand(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("brandList.edit")) + " ")]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), record.brandStatus == 0 ? _c("a-button", {
          staticStyle: {
            padding: "0"
          },
          attrs: {
            type: "link",
            loading: record.updateBrandStatusLoading
          },
          on: {
            click: function click($event) {
              return _vm.changStatus(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("brandList.startUsing")))]) : _c("a-button", {
          staticStyle: {
            padding: "0"
          },
          attrs: {
            type: "link",
            loading: record.updateBrandStatusLoading
          },
          on: {
            click: function click($event) {
              return _vm.changStatus(record);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("brandList.stopUsing")) + " ")]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.deletePromp"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirm(record.id);
            },
            cancel: _vm.cancel
          }
        }, [_c("a-button", {
          staticStyle: {
            padding: "0"
          },
          attrs: {
            type: "link"
          }
        }, [_vm._v(_vm._s(_vm.$t("brandList.delete")))])], 1)];
      }
    }])
  })], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("brandList.addBrand"),
      width: "1007px",
      centered: true,
      maskClosable: false
    },
    model: {
      value: _vm.addMondalVisible,
      callback: function callback($$v) {
        _vm.addMondalVisible = $$v;
      },
      expression: "addMondalVisible"
    }
  }, [_c("a-form-model", {
    ref: "addModal",
    attrs: {
      model: _vm.fromData,
      rules: _vm.rules,
      id: "modal"
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 40
    }
  }, [_vm._l(_vm.fromData.multilingualList, function (brandNameObj, index) {
    return [brandNameObj.required ? [_c("a-col", {
      attrs: {
        sm: 12
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: brandNameObj.titleName,
        prop: "brandName" + index
      }
    }, [_c("a-input", {
      attrs: {
        placeholder: "",
        allowClear: "",
        maxLength: 100
      },
      on: {
        focus: function focus($event) {
          return _vm.showFYBtn(brandNameObj);
        }
      },
      model: {
        value: brandNameObj.name,
        callback: function callback($$v) {
          _vm.$set(brandNameObj, "name", $$v);
        },
        expression: "brandNameObj.name"
      }
    }), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("brandList.translate")) + " ")]), _c("img", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: brandNameObj.showNameFY,
        expression: "brandNameObj.showNameFY"
      }],
      staticStyle: {
        width: "20px",
        top: "2px",
        right: "-22px",
        position: "absolute",
        cursor: "pointer"
      },
      attrs: {
        src: _vm.fanyiPic,
        alt: ""
      }
    })], 2)], 1)], 1), _c("a-col", {
      attrs: {
        sm: 12
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: brandNameObj.firstLetterName,
        prop: "firstLetter" + index
      }
    }, [_c("a-select", {
      attrs: {
        placeholder: _vm.$t("brandList.choosePlease")
      },
      model: {
        value: brandNameObj.firstLetters,
        callback: function callback($$v) {
          _vm.$set(brandNameObj, "firstLetters", $$v);
        },
        expression: "brandNameObj.firstLetters"
      }
    }, _vm._l(26, function (one) {
      return _c("a-select-option", {
        attrs: {
          value: String.fromCharCode(64 + one)
        }
      }, [_vm._v(" " + _vm._s(String.fromCharCode(64 + one)) + " ")]);
    }), 1)], 1)], 1)] : [_c("a-col", {
      attrs: {
        sm: 12
      }
    }, [_c("a-form-model-item", {
      staticStyle: {
        position: "relative"
      },
      attrs: {
        label: brandNameObj.titleName,
        prop: "brandName" + index
      }
    }, [_c("a-input", {
      attrs: {
        placeholder: "",
        allowClear: "",
        maxLength: 100
      },
      on: {
        focus: function focus($event) {
          return _vm.showFYBtn(brandNameObj);
        }
      },
      model: {
        value: brandNameObj.name,
        callback: function callback($$v) {
          _vm.$set(brandNameObj, "name", $$v);
        },
        expression: "brandNameObj.name"
      }
    }), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("brandList.translate")) + " ")]), _c("img", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: brandNameObj.showNameFY,
        expression: "brandNameObj.showNameFY"
      }],
      staticStyle: {
        width: "20px",
        top: "2px",
        right: "-22px",
        position: "absolute",
        cursor: "pointer"
      },
      attrs: {
        src: _vm.fanyiPic,
        alt: ""
      }
    })], 2)], 1)], 1), _c("a-col", {
      attrs: {
        sm: 12
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: brandNameObj.firstLetterName,
        prop: "firstLetter" + index
      }
    }, [_c("a-select", {
      attrs: {
        placeholder: _vm.$t("brandList.choosePlease"),
        disabled: brandNameObj.name ? false : true
      },
      model: {
        value: brandNameObj.firstLetters,
        callback: function callback($$v) {
          _vm.$set(brandNameObj, "firstLetters", $$v);
        },
        expression: "brandNameObj.firstLetters"
      }
    }, _vm._l(26, function (one) {
      return _c("a-select-option", {
        attrs: {
          value: String.fromCharCode(64 + one)
        }
      }, [_vm._v(" " + _vm._s(String.fromCharCode(64 + one)) + " ")]);
    }), 1)], 1)], 1)]];
  })], 2)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return function () {
          _vm.addMondalVisible = false;
        }.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("brandList.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.creatLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return function () {
          _vm.addSubmit();
        }.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("brandList.confirm")) + " ")])], 1)], 2), _c("a-modal", {
    attrs: {
      title: _vm.$t("brandList.editBrand"),
      width: "1007px",
      centered: true,
      maskClosable: false
    },
    model: {
      value: _vm.editModal,
      callback: function callback($$v) {
        _vm.editModal = $$v;
      },
      expression: "editModal"
    }
  }, [_c("a-form-model", {
    ref: "editModal",
    attrs: {
      model: _vm.fromDataForEdit,
      rules: _vm.rulesForEdite,
      id: "modal"
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 40
    }
  }, [_vm._l(_vm.fromDataForEdit.multilingualList, function (brandNameObj, index) {
    return [brandNameObj.required ? [_c("a-col", {
      attrs: {
        sm: 12
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: brandNameObj.titleName,
        prop: "brandName" + index
      }
    }, [_c("a-input", {
      attrs: {
        placeholder: "",
        allowClear: "",
        maxLength: 100
      },
      on: {
        focus: function focus($event) {
          return _vm.showFYBtnForEdit(brandNameObj);
        }
      },
      model: {
        value: brandNameObj.name,
        callback: function callback($$v) {
          _vm.$set(brandNameObj, "name", $$v);
        },
        expression: "brandNameObj.name"
      }
    }), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("brandList.translate")) + " ")]), _c("img", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: brandNameObj.showNameFY,
        expression: "brandNameObj.showNameFY"
      }],
      staticStyle: {
        width: "20px",
        top: "2px",
        right: "-22px",
        position: "absolute",
        cursor: "pointer"
      },
      attrs: {
        src: _vm.fanyiPic,
        alt: ""
      }
    })], 2)], 1)], 1), _c("a-col", {
      attrs: {
        sm: 12
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: brandNameObj.firstLetterName,
        prop: "firstLetter" + index
      }
    }, [_c("a-select", {
      attrs: {
        placeholder: _vm.$t("brandList.choosePlease")
      },
      model: {
        value: brandNameObj.firstLetters,
        callback: function callback($$v) {
          _vm.$set(brandNameObj, "firstLetters", $$v);
        },
        expression: "brandNameObj.firstLetters"
      }
    }, _vm._l(26, function (one) {
      return _c("a-select-option", {
        attrs: {
          value: String.fromCharCode(64 + one)
        }
      }, [_vm._v(" " + _vm._s(String.fromCharCode(64 + one)) + " ")]);
    }), 1)], 1)], 1)] : [_c("a-col", {
      attrs: {
        sm: 12
      }
    }, [_c("a-form-model-item", {
      staticStyle: {
        position: "relative"
      },
      attrs: {
        label: brandNameObj.titleName,
        prop: "brandName" + index
      }
    }, [_c("a-input", {
      attrs: {
        placeholder: "",
        allowClear: "",
        maxLength: 100
      },
      on: {
        focus: function focus($event) {
          return _vm.showFYBtnForEdit(brandNameObj);
        }
      },
      model: {
        value: brandNameObj.name,
        callback: function callback($$v) {
          _vm.$set(brandNameObj, "name", $$v);
        },
        expression: "brandNameObj.name"
      }
    }), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("brandList.translate")) + " ")]), _c("img", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: brandNameObj.showNameFY,
        expression: "brandNameObj.showNameFY"
      }],
      staticStyle: {
        width: "20px",
        top: "2px",
        right: "-22px",
        position: "absolute",
        cursor: "pointer"
      },
      attrs: {
        src: _vm.fanyiPic,
        alt: ""
      }
    })], 2)], 1)], 1), _c("a-col", {
      attrs: {
        sm: 12
      }
    }, [_c("a-form-model-item", {
      attrs: {
        label: brandNameObj.firstLetterName,
        prop: "firstLetter" + index
      }
    }, [_c("a-select", {
      attrs: {
        placeholder: _vm.$t("brandList.choosePlease"),
        disabled: brandNameObj.name ? false : true
      },
      model: {
        value: brandNameObj.firstLetters,
        callback: function callback($$v) {
          _vm.$set(brandNameObj, "firstLetters", $$v);
        },
        expression: "brandNameObj.firstLetters"
      }
    }, _vm._l(26, function (one) {
      return _c("a-select-option", {
        attrs: {
          value: String.fromCharCode(64 + one)
        }
      }, [_vm._v(" " + _vm._s(String.fromCharCode(64 + one)) + " ")]);
    }), 1)], 1)], 1)]];
  })], 2)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return function () {
          _vm.editModal = false;
        }.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("brandList.cancel")))]), _c("a-button", {
    attrs: {
      loading: _vm.editLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return function () {
          _vm.editSubmit();
        }.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("brandList.confirm")) + " ")])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };